import { useId } from "react";

import { ILLUSTRATION_ARTS } from "./illustration.constants";
import type { IllustrationProps, IllustrationViewModel } from "./types-illustration";

/** ViewModel da Illustration: a arte escolhida, a largura do `natural` e a acessibilidade (`role`, `aria-*`, `id` do título); sem JSX. */
export function useIllustration({
  name,
  size = "md",
  title,
  decorative,
  className,
  style,
  testId,
  ...rest
}: IllustrationProps): IllustrationViewModel {
  const titleId = useId();
  const { Component, figma, viewBox } = ILLUSTRATION_ARTS[name];

  return {
    Art: Component,
    viewBox,
    figma,
    size,
    width: size === "natural" ? Number(viewBox.split(" ")[2]) : undefined,
    title,
    titleId,
    role: title ? "img" : undefined,
    ariaLabelledBy: title ? titleId : undefined,
    ariaHidden: title ? undefined : (decorative ?? true),
    testId,
    className,
    style,
    rest,
  };
}
